import './quiz_archive.scss';
import './img/logitech_quiz.jpg';



// WEBPACK FOOTER //
// ./resources/views/partials/quiz_type/archive/quiz_archive.js